import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './index.css';
import earthFlag from '../../../assets/img/other/flag-earth.svg';
import superFlag from '../../../assets/img/other/super-flag.png';

class FilterLocation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {location: props.initialValue};
  }

  toggleLocation(value) {
    const location =
      this.state.location === value &&
      this.props.availableButtons.includes('ALL')
        ? 'ALL'
        : value;
    this.setState({location});
    this.props.onChange(location);
  }

  renderButton(location, key) {
    const btnClassName = 'btn btn-box-tool';
    switch (location) {
      case 'ALL':
        return false;
      case 'FR2':
        return (
          <button
            key={key}
            style={{position: 'relative'}}
            className={classNames(btnClassName, {
              selected: this.state.location === location,
            })}
            onClick={() => this.toggleLocation(location)}
            {...this.props.buttonsProps}>
            <span
              className={classNames('btnFr2', {
                fr2Selected: this.state.location === location,
              })}>
              2
            </span>
            <span className="flag-icon flag-icon-fr" />
          </button>
        );
      case 'SUPER':
        return (
          <button
            key={key}
            className={classNames(btnClassName, {
              selected: this.state.location === location,
            })}
            onClick={() => this.toggleLocation(location)}
            {...this.props.buttonsProps}>
            <img src={superFlag} alt="Super Ligue" className="flag-img-btn" />
          </button>
        );
      case 'OTHER':
        return (
          <button
            key={key}
            className={classNames(btnClassName, {
              selected: this.state.location === 'OTHER',
            })}
            onClick={() => this.toggleLocation('OTHER')}
            {...this.props.buttonsProps}>
            <img
              src={earthFlag}
              alt="Drapeau de la terre"
              className="flag-img-btn"
            />
          </button>
        );
      default:
        return (
          <button
            key={key}
            className={classNames(btnClassName, {
              selected: this.state.location === location,
            })}
            onClick={() => this.toggleLocation(location)}
            {...this.props.buttonsProps}>
            <span className={`flag-icon flag-icon-${location.toLowerCase()}`} />
          </button>
        );
    }
  }

  render() {
    const {label, availableButtons} = this.props;
    return (
      <div className="location-filter inline" style={{margin: 12}}>
        {label && [
          <label key="location-filter-label-1">{label}</label>,
          <br key="location-filter-label-2" />,
        ]}
        {availableButtons.map((location, i) =>
          this.renderButton(location, `location-filter-btn-${i}`),
        )}
      </div>
    );
  }
}

FilterLocation.propTypes = {
  availableButtons: PropTypes.arrayOf(PropTypes.string),
  buttonsProps: PropTypes.object,
  initialValue: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

FilterLocation.defaultProps = {
  availableButtons: ['ALL', 'ES', 'GB', 'FR', 'SUPER', 'OTHER'],
  buttonsProps: {},
  initialValue: 'ALL',
};

export default FilterLocation;



// WEBPACK FOOTER //
// ./src/components/Filters/Location/index.js